"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceUser = void 0;
var SourceUser;
(function (SourceUser) {
    SourceUser["SELLER_PORTAL"] = "Seller Portal";
    SourceUser["STOP_SHIP_BY_DAYS"] = "Stop ship by days";
    SourceUser["POSTMAN"] = "Postman";
})(SourceUser = exports.SourceUser || (exports.SourceUser = {}));
//# sourceMappingURL=LotStateSourceUser.js.map